<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-8 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">{{trans('school.school')}}
                        </h2>
                        <div class="breadcrumb-wrapper col-12">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link to="/home">
                                        {{ trans('general.home') }}
                                    </router-link>
                                </li>
                                <li class="breadcrumb-item">
                                    <router-link to="/school">
                                        {{ trans('school.school') }}
                                    </router-link>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ trans('school.school_file_upload') }}
                                </li>


                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-header-right text-md-right col-md-4 col-12 d-md-block d-none">
                <div class="form-group breadcrum-right">
                    <button class="btn btn-primary btn-sm pull-right" @click="$router.push('/schools')"><i class="feather icon-list"></i> {{trans('school.school_list')}}</button>
                    
                </div>
            </div>

        </div>

        <div class="content-body">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">{{trans('school.school_file_upload')}}</h4>
                </div>

                <div class="card-content">
                    <div class="card-body">
                        <form @submit.prevent="proceed" @keydown="schoolForm.errors.clear($event.target.name)">
                                    <div class="row">
                                        
        <div class="col-md-12 mb-1">
            <a href="/files/schools.xlsx" download class="btn btn-primary btn-sm waves-effect waves-float waves-light pull-left"><i class="fas fa-download"></i> {{ trans('general.download_sample') }}</a>
            
        </div>
                                        
                                        <div class="col-xl-12 col-md-6 col-12">
                                            <div class="form-group">
                    <label for="">{{trans('school.lga')}}</label>
                    <select class="form-control" :class="{ 'is-invalid': schoolForm.errors.has('lga_id') }" name="lga_id" v-model="schoolForm.lga_id">
                        <option value="">{{trans('school.lga')}}</option>
                        <option v-for="lga in lgas" :value="lga.id">{{lga.name}}</option>
                    </select>
                    <show-error :form-name="schoolForm" prop-name="lga_id"></show-error>
                </div>
                                        </div>
                                        <div class="col-xl-6 col-md-6 col-12">
                                            <div class="form-group">
                                                <file-upload-input :button-text="trans('general.excel')" :token="schoolForm.upload_token" module="school" :clear-file="clear_message_attachment" :module-id="schoolForm.id"></file-upload-input>    
                                            </div>
                                        </div>
                                        
                                        
                                    </div>
                                    <div class="row">
                                        <div class="col-md-8 offset-md-4">
                                            <button-spinner
                                                :is-loading="schoolForm.isLoading" 
                                                :disabled="schoolForm.isLoading"
                                                
                                                class="btn btn-primary mr-1 mb-1 waves-effect waves-light pull-right"
                                                style="height: 39px; color: #fff;"
                                                >
                                                <span>{{trans('general.save')}}</span>
                                            </button-spinner>

        <router-link to="/schools" class="btn btn-danger waves-effect waves-light pull-right mr-1 mb-1">{{trans('general.cancel')}}</router-link>
        
                                    </div>
                                    </div>
                                </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import fileUploadInput from '../../components/file-upload-input'
    import uuid from 'uuid/v4'

    export default {
        components : { fileUploadInput },
        data() {
            return {
                schoolForm: new Form({
                    isLoading: false,
                    id: '',
                    upload_token: '',
                    state_id: '',
                    lga_id: ''
                }),
                lgas: [],
                 clear_message_attachment: false,
            };
        },
        mounted(){
            if(!helper.hasPermission('create-schools')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            if(!helper.featureAvailable('school')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }
            this.schoolForm.upload_token = uuid();
            this.fetchPreRequisites();
        },
         methods: {
            fetchPreRequisites(){
                axios.get('/api/user/pre-requisite')
                    .then(response => response.data)
                    .then(response => {
                        this.lgas = response.lgas;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error)
                    });
            },
            proceed(){
                this.storeUpload();
            },
            storeUpload(){
                this.schoolForm.isLoading = true;
                this.schoolForm.post('/api/schools/import')
                    .then(response => {
                        toastr.success(response.message);
                        this.schoolForm.isLoading = false;
                        this.clear_message_attachment = true;
                        this.$router.push('/schools');
                    })
                    .catch(error => {
                        this.schoolForm.isLoading = false;
                        toastr.error(error.message);
                        helper.showErrorMsg(error);
                    });
            }
        }
    }
</script>
